import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/public/assets/images/hero/SocBanner.webp");
;
import(/* webpackMode: "eager", webpackExports: ["NewsListSection"] */ "/var/www/SOC/src/sections/news-list/index.tsx");
